import { createSlice } from '@reduxjs/toolkit'

export type SnackbarStatus = 'info' | 'success' | 'warning' | 'error' | 'neutral'
export interface SnackbarState {
  message: string
  status: SnackbarStatus
  timeout?: number
}

const initialState: SnackbarState = {
  message: '',
  status: 'neutral',
  timeout: 10000
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.status = action.payload.status
      state.message = action.payload.message
      state.timeout = action.payload.timeout
    }
  }
})

export const { actions, reducer } = snackbarSlice
